var _mask, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 558,
    viewBox: "0 0 530 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 530,
    height: 558
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.582031,
    width: 530,
    height: 556.672,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.582031,
    width: 581.69,
    height: 573.333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -2.46472,
    cy: 279.408,
    rx: 278.521,
    ry: 276.866,
    fill: "#F2F4FE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -1.97182,
    cy: 278.919,
    rx: 246.479,
    ry: 245.014,
    fill: "#49DBA3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -2.46462,
    cy: 279.408,
    rx: 37.9577,
    ry: 37.7322,
    fill: "#E9ECFC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.873 448.984C148.873 430.923 158.093 416.281 169.466 416.281C176.614 416.281 182.909 422.068 186.602 430.849C187.849 430.335 189.186 430.068 190.537 430.065C193.979 430.065 197.162 431.818 199.758 434.786C203.086 423.836 210.144 416.281 218.313 416.281C225.951 416.281 232.613 422.89 236.168 432.699C238.143 431.042 240.631 430.112 243.215 430.065C251.943 430.065 259.019 441.301 259.019 455.162C259.055 459.783 258.21 464.368 256.529 468.676H153.026C150.42 463.198 148.873 456.379 148.873 448.984Z",
    fill: "#29C88B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-9.15527e-05 470.029H430.845V468.069H-9.15527e-05V470.029Z",
    fill: "#6FEFBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 400.445H477.183V398.485H0V400.445Z",
    fill: "#47EDAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.559 373.386C160.571 383.051 159.351 397.908 159.351 397.908C159.351 397.908 174.324 397.095 184.312 387.43C194.3 377.765 195.52 362.908 195.52 362.908C195.52 362.908 180.546 363.721 170.559 373.386Z",
    fill: "#6FEFBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M206.47 376.259C202.83 389.634 190.363 397.917 190.363 397.917C190.363 397.917 183.797 384.516 187.437 371.141C191.077 357.766 203.544 349.482 203.544 349.482C203.544 349.482 210.11 362.884 206.47 376.259Z",
    fill: "#3F3D56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M212.692 387.308C204.11 396.564 190.567 398.033 190.567 398.033C190.567 398.033 190.938 384.496 199.521 375.24C208.103 365.984 221.646 364.515 221.646 364.515C221.646 364.515 221.274 378.053 212.692 387.308Z",
    fill: "#6FEFBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.719 234.661L192.321 229.41L155.347 196.594H61.5927V225.472L122.335 266.164L185.719 234.661Z",
    fill: "#29B17D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4994 215.002V197.249H56.9473V201.597L61.593 196.594L91.9644 229.41L103.849 237.286L122.276 371.116L94.4855 398.741H29.9011V230.722L44.4994 215.002Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.964 229.41H192.321V398.741H91.964V229.41Z",
    fill: "#F2F2F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.88776 386.33C7.88776 375.181 14.9022 366.144 23.555 366.144C28.9934 366.144 33.7832 369.715 36.5924 375.136C37.5571 374.816 38.5684 374.652 39.5865 374.652C42.2195 374.695 44.7333 375.74 46.6019 377.566C49.1341 370.807 54.5038 366.144 60.719 366.144C66.5301 366.144 71.5985 370.223 74.3032 376.278C75.8898 375.23 77.7546 374.664 79.6653 374.652C86.3058 374.652 91.689 381.588 91.689 390.144C91.7085 393.03 91.0607 395.882 89.7947 398.485H11.0474C8.93578 394.774 7.84658 390.584 7.88776 386.33Z",
    fill: "#49DBA3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134.88 357.393H153.367V398.741H134.88V357.393Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.174 369.206V362.643H181.097V369.206H173.834H173.174Z",
    fill: "#6FEFBD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M173.834 374.457H181.097V381.02H173.174V374.457H173.834Z",
    fill: "#6FEFBD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M159.969 362.644H167.892V369.207H159.969V362.644Z",
    fill: "#6FEFBD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M159.969 374.457H167.892V381.02H159.969V374.457Z",
    fill: "#6FEFBD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.034 369.206V362.643H126.957V369.206H119.694H119.034Z",
    fill: "#6FEFBD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M119.694 374.457H126.957V381.02H119.034V374.457H119.694Z",
    fill: "#6FEFBD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105.829 362.644H113.752V369.207H105.829V362.644Z",
    fill: "#6FEFBD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M105.829 374.457H113.752V381.02H105.829V374.457Z",
    fill: "#6FEFBD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5735 237.942V231.379H71.4966V237.942H64.2337H63.5735Z",
    fill: "#29B17D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2337 243.193H71.4966V249.756H63.5735V243.193H64.2337Z",
    fill: "#29B17D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3676 231.379H58.2905V237.942H50.3676V231.379Z",
    fill: "#29B17D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3676 243.192H58.2905V249.756H50.3676V243.192Z",
    fill: "#29B17D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5735 274.696V268.133H71.4966V274.696H64.2337H63.5735Z",
    fill: "#29B17D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2337 279.946H71.4966V286.51H63.5735V279.946H64.2337Z",
    fill: "#29B17D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3676 268.133H58.2905V274.696H50.3676V268.133Z",
    fill: "#29B17D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3676 279.946H58.2905V286.51H50.3676V279.946Z",
    fill: "#29B17D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5735 311.45V304.887H71.4966V311.45H64.2337H63.5735Z",
    fill: "#29B17D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2337 316.701H71.4966V323.264H63.5735V316.701H64.2337Z",
    fill: "#29B17D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3676 304.887H58.2905V311.45H50.3676V304.887Z",
    fill: "#29B17D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3676 316.701H58.2905V323.264H50.3676V316.701Z",
    fill: "#29B17D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5735 348.204V341.641H71.4966V348.204H64.2337H63.5735Z",
    fill: "#29B17D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2337 353.455H71.4966V360.018H63.5735V353.455H64.2337Z",
    fill: "#29B17D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3676 341.641H58.2905V348.204H50.3676V341.641Z",
    fill: "#29B17D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3676 353.455H58.2905V360.018H50.3676V353.455Z",
    fill: "#29B17D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M104.508 237.942H181.097V253.694H104.508V237.942Z",
    fill: "#6FEFBD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M104.508 269.445H181.097V285.197H104.508V269.445Z",
    fill: "#6FEFBD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M104.508 300.949H181.097V316.701H104.508V300.949Z",
    fill: "#6FEFBD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M104.508 332.452H181.097V348.204H104.508V332.452Z",
    fill: "#6FEFBD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M196.915 470.488C195.429 470.488 194.225 465.7 194.225 459.793C194.225 453.886 195.429 449.098 196.915 449.098C198.4 449.098 199.605 453.886 199.605 459.793C199.605 465.7 198.4 470.488 196.915 470.488Z",
    fill: "#2F2E41"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M212.606 230.726C211.12 230.726 209.916 225.937 209.916 220.03C209.916 214.123 211.12 209.335 212.606 209.335C214.091 209.335 215.295 214.123 215.295 220.03C215.295 225.937 214.091 230.726 212.606 230.726Z",
    fill: "#2F2E41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M228.465 261.133C227.842 275.157 232.131 288.963 240.6 300.196C249.069 311.43 261.195 319.397 274.911 322.74C288.627 326.083 303.085 324.595 315.821 318.529C328.557 312.464 338.783 302.196 344.757 289.476C350.731 276.755 352.083 262.369 348.583 248.769C345.083 235.169 336.948 223.195 325.563 214.889C314.178 206.583 300.248 202.458 286.146 203.217C272.045 203.976 258.644 209.572 248.228 219.052C242.298 224.419 237.498 230.901 234.106 238.124C230.714 245.348 228.796 253.168 228.465 261.133ZM349.962 266.46C348.491 299.631 320.146 325.427 286.777 323.963C253.408 322.5 227.458 294.324 228.93 261.153C230.402 227.983 258.747 202.187 292.116 203.65C325.484 205.113 351.434 233.29 349.962 266.46Z",
    fill: "#6FEFBD"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M327.117 228.164C327.395 221.899 332.889 217.051 339.388 217.336C345.888 217.621 350.932 222.931 350.654 229.196C350.376 235.461 344.881 240.309 338.382 240.024C331.882 239.739 326.839 234.429 327.117 228.164Z",
    fill: "#6FEFBD"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M295.159 268.846C285.59 268.846 277.833 261.135 277.833 251.623C277.833 242.111 285.59 234.399 295.159 234.399C304.728 234.399 312.486 242.111 312.486 251.623C312.486 261.135 304.728 268.846 295.159 268.846Z",
    fill: "#030822"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M300.698 264.371C300.698 264.371 299.802 280.414 301.595 280.414C303.388 280.414 290.387 287.99 290.387 287.99L282.318 283.534V278.186C282.318 278.186 293.077 276.849 288.594 265.262C284.111 253.676 300.698 264.371 300.698 264.371Z",
    fill: "#9F616A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M338.355 440.398L339.7 453.768L335.217 455.104L331.631 451.54L330.286 440.398H338.355Z",
    fill: "#9F616A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M273.799 447.976L271.558 456.442L265.282 460.453L258.557 456.888L266.178 444.41L273.799 447.976Z",
    fill: "#9F616A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M296.438 271.279C289.258 271.279 283.438 265.493 283.438 258.355C283.438 251.218 289.258 245.432 296.438 245.432C303.619 245.432 309.439 251.218 309.439 258.355C309.439 265.493 303.619 271.279 296.438 271.279Z",
    fill: "#9F616A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M304.284 306.707L307.422 305.371C307.422 305.371 312.802 302.251 313.25 296.012C313.698 289.773 308.767 281.752 308.767 281.752L301.594 279.523L293.167 286.342L293.076 297.349L304.284 306.707Z",
    fill: "#9F616A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M307.422 282.642L309.216 281.751C309.216 281.751 318.182 281.305 319.078 292C319.975 302.696 323.113 320.521 323.113 320.521C323.113 320.521 330.286 332.999 329.838 346.368L333.424 357.955C333.424 357.955 338.355 374.889 332.527 374.889C326.699 374.889 327.148 356.618 327.148 356.618C327.148 356.618 316.388 330.771 315.492 326.315C314.595 321.858 306.974 300.913 309.216 295.12C311.457 289.327 307.422 282.642 307.422 282.642Z",
    fill: "#9F616A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M300.698 310.718V315.62C300.698 315.62 297.559 319.185 298.904 321.413C300.249 323.641 301.594 328.098 301.594 328.098L295.318 337.902L274.248 339.684L270.058 311.778L300.698 310.718Z",
    fill: "#9F616A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M280.972 279.523L277.386 277.74C277.386 277.74 269.765 272.393 263.489 271.501L244.212 258.578L231.659 228.72C231.659 228.72 232.107 212.677 228.521 214.46C224.934 216.242 225.383 230.057 225.383 230.057C225.383 230.057 232.107 257.687 237.935 265.262C243.763 272.838 264.833 285.316 264.833 285.316C264.833 285.316 270.661 292.001 270.213 295.12C269.765 298.24 280.972 279.523 280.972 279.523Z",
    fill: "#9F616A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M297.56 328.098C297.56 328.098 302.491 324.978 305.629 330.326C308.767 335.674 314.595 337.011 318.182 353.054C321.768 369.097 330.286 394.498 332.527 396.281C334.769 398.063 344.183 416.78 338.803 443.073H329.837L322.216 405.193C322.216 405.193 297.56 374.89 295.766 362.412L287.697 409.204C287.697 409.204 287.249 427.03 280.524 435.497L273.351 452.431L263.937 447.975L274.696 405.193C274.696 405.193 269.316 361.966 272.903 349.934L273.418 334.16C273.418 334.16 288.145 334.782 297.56 328.098Z",
    fill: "#2F2E41"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M335.217 451.54H340.597C341.494 451.54 348.667 457.333 345.528 460.453C342.39 463.572 337.459 469.366 337.459 469.366C337.459 469.366 319.975 471.576 319.527 468.456C319.078 465.337 327.148 458.67 327.148 458.67L329.39 451.54C329.39 451.54 333.873 446.638 335.217 451.54Z",
    fill: "#2F2E41"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M263.937 455.996C263.937 455.996 271.558 455.551 272.903 455.105C274.248 454.659 276.937 466.692 272.903 467.583C268.868 468.474 252.281 469.811 252.281 469.811C252.281 469.811 239.28 469.365 240.177 465.8C241.073 462.235 258.557 455.105 258.557 455.105C258.557 455.105 260.799 450.649 263.937 455.996Z",
    fill: "#2F2E41"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M299.353 279.077L301.594 277.74L304.284 279.968C304.284 279.968 296.215 285.316 298.008 290.218C299.801 295.12 307.422 305.37 307.422 305.37C307.422 305.37 300.698 312.946 300.698 315.62C300.698 315.62 283.214 309.381 270.213 315.62C270.213 315.62 270.213 306.707 268.42 304.924C266.627 303.142 265.73 296.903 270.213 291.555C273.371 287.62 276.219 283.448 278.731 279.077L283.214 276.403L285.523 277.131C285.523 277.131 280.972 282.197 285.455 282.642C289.938 283.088 297.111 281.751 299.353 279.077Z",
    fill: "#6FEFBD"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M282.495 222.259C284.019 223.949 286.105 225.035 288.37 225.318C292.286 225.874 289.209 231.991 289.209 231.991C289.209 231.991 290.328 229.767 288.09 227.82C285.852 225.874 282.495 224.761 282.495 222.259Z",
    fill: "#030822"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M290.047 238.07C287.38 238.07 285.218 235.921 285.218 233.27C285.218 230.619 287.38 228.47 290.047 228.47C292.713 228.47 294.875 230.619 294.875 233.27C294.875 235.921 292.713 238.07 290.047 238.07Z",
    fill: "#030822"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M284.409 237.997C288.139 236.06 294.557 234.536 297.966 234.645L297.104 231.367C294.085 233.406 287.702 234.958 283.546 234.719L284.409 237.997Z",
    fill: "#49DBA3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M292.116 238.285C292.116 238.285 297.995 245.798 309.751 247.468C321.508 249.137 312.271 267.502 312.271 267.502C312.271 267.502 315.63 260.824 308.912 254.981C302.194 249.137 292.116 245.798 292.116 238.285Z",
    fill: "#030822"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M291.668 237.839C291.668 237.839 288.309 249.526 283.27 251.195C278.232 252.865 280.751 270.395 289.148 272.064C289.148 272.064 282.011 262.465 286.209 254.952C290.408 247.439 292.927 241.595 291.668 237.839Z",
    fill: "#030822"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M212.606 218.248H243.539V221.813H212.606V218.248Z",
    fill: "#2F2E41"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M243.539 230.726C242.054 230.726 240.849 225.937 240.849 220.03C240.849 214.123 242.054 209.335 243.539 209.335C245.025 209.335 246.229 214.123 246.229 220.03C246.229 225.937 245.025 230.726 243.539 230.726Z",
    fill: "#2F2E41"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M196.916 458.01H227.849V461.575H196.916V458.01Z",
    fill: "#2F2E41"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M227.848 470.488C226.363 470.488 225.158 465.7 225.158 459.793C225.158 453.886 226.363 449.098 227.848 449.098C229.334 449.098 230.538 453.886 230.538 459.793C230.538 465.7 229.334 470.488 227.848 470.488Z",
    fill: "#2F2E41"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M371.691 385.022C371.691 371.889 379.871 361.243 389.961 361.243C396.302 361.243 401.888 365.45 405.163 371.836C406.288 371.458 407.467 371.266 408.655 371.265C411.725 371.317 414.656 372.547 416.835 374.698C419.788 366.736 426.049 361.243 433.297 361.243C440.073 361.243 445.983 366.049 449.137 373.181C450.987 371.946 453.162 371.28 455.39 371.265C463.133 371.265 469.41 379.435 469.41 389.514C469.433 392.913 468.678 396.273 467.201 399.34H375.376C372.914 394.968 371.643 390.032 371.691 385.022Z",
    fill: "#49DBA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.1489b80dc787de6b2a1e2fbc0721111d.svg";
export { ForwardRef as ReactComponent };